import { useEffect } from 'react';

function useDivScrollTrigger(divRef, callback, loading, setLoading) {
  useEffect(() => {
    const divElement = divRef.current;

    const handleScroll = () => {
      if (divElement) {
        if (divElement.scrollHeight - divElement.scrollTop <= divElement.clientHeight + 10) {
          if (!loading) {

            setLoading(true);
            callback();
          }
        }
      }
    };

    if (divElement) {
      divElement.addEventListener('scroll', handleScroll);
      return () => divElement.removeEventListener('scroll', handleScroll);
    }
  }, [divRef, callback, loading, setLoading]);
}

export default useDivScrollTrigger;
